import React, { memo, useState } from "react";
import PropTypes, { node } from "prop-types";
import {
  Box,
  FormHelperText,
  TextField,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

import "./index.css";

const SharedInputField = (props) => {
  const {
    className,
    name,
    onChange,
    variant,
    errorMsg,
    label,
    value,
    required = false,
    placeholder,
    type,
    onBlur,
    disabled,
    multiline,
    rows,
    nowrap,
    isPasswordField = false,
    onKeyPress,
    inputProps = {},
    InputProps = {},
    endAdornment,
    Prefix = null,
    style,
  } = props;
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleKeyPress = (event) => {
    if (onKeyPress) {
      onKeyPress(event);
    }

    event.preventDefault();
  };

  return (
    <div className="shared-input-field" style={style}>
      {label && (
        <Box
          className="form-label"
          style={nowrap ? { whiteSpace: "nowrap" } : null}
        >
          {required && !disabled && <p className="required">*</p>}
          {label}
        </Box>
      )}

      <Box style={{ display: "flex", alignItems: "center" }}>
        {Prefix}

        <TextField
          // onKeyPress={handleKeyPress}
          onKeyPress={onKeyPress}
          size="medium"
          variant={variant}
          onBlur={onBlur}
          onChange={onChange}
          value={type !== "number" ? value || "" : value}
          error={errorMsg ? true : false}
          type={isPasswordField ? (showPassword ? "text" : type) : type}
          name={name}
          disabled={disabled}
          placeholder={placeholder}
          multiline={multiline}
          rows={rows}
          className={className}
          InputProps={
            isPasswordField
              ? {
                  ...InputProps,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }
              : endAdornment
              ? {
                  ...InputProps,
                  endAdornment: endAdornment,
                }
              : InputProps
          }
          inputProps={inputProps}
          style={{
            flex: 1,
          }}
        />
      </Box>

      {errorMsg && (
        <FormHelperText className="error-message">{errorMsg}</FormHelperText>
      )}
    </div>
  );
};

SharedInputField.propTypes = {
  variant: PropTypes.oneOf(["filled", "outlined", "standard"]),
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  errorMsg: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  endAdornment: node,
};

SharedInputField.defaultProps = {
  onChange: null,
  variant: "outlined",
  errorMsg: "",
  label: "",
  required: false,
  type: "text",
  placeholder: "",
};

export default memo(SharedInputField);
